import UserCallerIds from '@Containers/UserCallerIds/UserCallerIds.container';

const UserCallerIdsPage: React.FunctionComponent = (): JSX.Element => (
  <UserCallerIds />
);

export default UserCallerIdsPage;
